import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { useWorkspace } from '../contexts/WorkspaceContext';
import { AuthContext } from '../App';

/**
 * Renders an amber banner across the top of the app whenever a super admin is
 * viewing a workspace they aren't actually a member of. Suppressed inside the
 * /super-admin/* routes (those screens are already global by design).
 */
export default function SuperAdminBanner() {
  const { user } = useContext(AuthContext);
  const { isInSuperAdminMode, switchWorkspace } = useWorkspace();
  const location = useLocation();

  if (!isInSuperAdminMode) return null;
  if (location.pathname.startsWith('/super-admin')) return null;

  const goHome = () => {
    if (user?.defaultWorkspaceId) {
      switchWorkspace(user.defaultWorkspaceId);
    }
  };

  return (
    <div
      role="status"
      style={{
        borderBottom: '1px solid var(--warning, #f59e0b)',
        background: 'var(--warning-bg, rgba(245, 158, 11, 0.12))',
        color: 'var(--text)',
        padding: '8px 16px',
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        fontSize: 13,
      }}
    >
      <strong style={{ color: 'var(--warning, #b45309)' }}>⚠ Süper Admin Modu</strong>
      <span style={{ color: 'var(--text-muted)' }}>
        Bu workspace'e üye değilsiniz; süper admin yetkilerinizle görüntülüyorsunuz.
      </span>
      {user?.defaultWorkspaceId ? (
        <button
          type="button"
          className="ox-btn ox-btn-ghost"
          style={{ marginLeft: 'auto' }}
          onClick={goHome}
        >
          Kendi workspace'ime dön
        </button>
      ) : null}
    </div>
  );
}
